export default __webpack_public_path__ + "images/watermark-ar-icon.b3ce7de048f058de009f014f60602cda.svg";